export default __webpack_public_path__ + "static/media/home-branding-agency-img-01.3191a5a7.jpg";